import { useMutation, useQuery, useQueryClient } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

// Shared with usePermissions so /person/self is fetched once for the whole app.
export const SELF_QUERY_KEY = 'self'

const deleteUser = async (userId) => {
  const { data } = await axios.delete(`${API_BASE_URL}/person/${userId}`)

  return data
}
const updateUser = async (userId, user) => {
  const { data } = await axios.patch(`${API_BASE_URL}/person/${userId}`, user)

  return data
}
const fetchUser = async (userId) => {
  const { data } = await axios.get(`${API_BASE_URL}/person/${userId}`)

  return data
}
const createUser = async (user) => {
  const { data } = await axios.post(`${API_BASE_URL}/person`, user)

  return data
}
export const fetchSelf = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/person/self`)

  return data
}
// api call to make a user admin or take away admin privileges, depending on the function parameter
// Per-user permission switches: any of can_upload, can_analyse, can_see_suborg_analyses.
export const updateUserPermissions = async (userId, permissions) => {
  const { data } = await axios.patch(`${API_BASE_URL}/person/${userId}/permissions`, permissions)
  return data
}

export const useUpdateUserPermissions = () => {
  const queryClient = useQueryClient()
  return useMutation(({ userId, permissions }) => updateUserPermissions(userId, permissions), {
    onSuccess: () => {
      queryClient.invalidateQueries(['user-list'])
      // The admin may have changed their own switches.
      queryClient.invalidateQueries(SELF_QUERY_KEY)
    },
  })
}

const toggleAdmin = async (userId, isAdmin) => {
  const { data } = await axios.patch(`${API_BASE_URL}/person/${userId}/admin`, { is_admin: isAdmin })

  // refresh the current page
  window.location.reload()

  return data
}

export const useManageUser = ({ id }) => {
  const queryClient = useQueryClient()

  const queryKey = ['user', id]

  const query = useQuery(queryKey, () => fetchUser(id))
  const self = useQuery(SELF_QUERY_KEY, () => fetchSelf())

  const onSuccess = () => queryClient.invalidateQueries(['user-list'])
  const insertMutation = useMutation((user) => createUser(user), { onSuccess })
  const deleteMutation = useMutation(() => deleteUser(id), { onSuccess })
  const updateMutation = useMutation((user) => updateUser(id, user))
  const toggleAdminMutation = useMutation((isAdmin) => toggleAdmin(id, isAdmin))

  return { self, query, insertMutation, deleteMutation, updateMutation, toggleAdminMutation }
}
